import React from "react";
import { popupMenuOptions } from "../parent/data/popupMenuOptions";

export const ReplaceCardModalContent = (props) => {
  
  const advance = (suspiciousActivity) => {    
      window.scrollTo(0, 0);
      let type = popupMenuOptions.valid.ReplaceCard;
      if (suspiciousActivity) {
        type = popupMenuOptions.invalid.ReplaceCardSuspiciousActivity;
      }

      props.setCardInfo((state) => {
        return {
          ...state,
          agreeNbr: props.agreeNbr,
          type: type,
          cardType: props.cardType
        };
      });
      props.closeModal();
  };

  return (
    <div>
      <div className="bold" style={{fontSize: "18px" }}>Is there suspicious activity on your card?</div>
      <button
        className="px-1 mx-1 w-25 modal-button"
        style={{ color: "#00558c", borderColor: "#00558c" }}
        onClick={() => {
          advance(true);
        }}
        data-e2e-id="proceed-card-update"
      >
        Yes
      </button>
      <button
        className="px-1 mx-1 w-25 modal-button"
        style={{ color: "#00558c", borderColor: "#00558c" }}
        onClick={() => {
          advance(false);
        }}
        data-e2e-id="cancel-card-update"
      >
        No
      </button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/card-controls/modal/replace-card-modal-content.component.js